// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OVenUQbBroCK0BmTtZ27{height:100%;width:100%;background-color:#f4f4f4;border-radius:10px}@media(max-width: 767px){.OVenUQbBroCK0BmTtZ27{border:1px solid #cbd5e0}}.OVenUQbBroCK0BmTtZ27 img{height:100%;width:100%;object-fit:contain;object-position:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatarPlaceholder": "OVenUQbBroCK0BmTtZ27"
};
export default ___CSS_LOADER_EXPORT___;
